// extracted by mini-css-extract-plugin
module.exports = {"instructions":"instructions_instructions__3PO-H","instructions__header":"instructions_instructions__header__auzGr"};